import { create } from 'zustand';

const DEFAULT_WIDTH = 144;
const DEFAULT_HEIGHT = 92;
export const useDrawerStore = create((set) => ({
  drawerOpen: false,
  setDrawerOpen: (open) => set({ drawerOpen: open }),
  collectionDrawerOpen: false,
  setCollectionDrawerOpen: (open) => set({ collectionDrawerOpen: open }),
  selectedTouchPoint: null,
  setSelectedTouchPoint: (touchPoint) => set({ selectedTouchPoint: touchPoint }),
  activeCabinet: null,
  setActiveCabinet: (cabinet) => set({ activeCabinet: cabinet }),
}));

export const useCabinetStore = create((set) => ({
  activeCabinet: null,
  setActiveCabinet: (cabinet) => set({ activeCabinet: cabinet }),
  patchActiveCabinet: (patchFn) => set((state) => ({
    activeCabinet: patchFn(state.activeCabinet),
  })),
  selectedCabinet: null,
  setSelectedCabinet: (cabinet) => set({ selectedCabinet: cabinet }),
}));

export const useViewportStore = create((set) => ({
  viewportInfo: {
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT,
    finalZoom: 1,
    scrollOffset: { scrollLeft: 0, scrollTop: 0 }
  },
  setViewportInfo: (info) => set({ viewportInfo: info }),
  setScrollOffset: (scrollOffset) => set((state) => ({
    viewportInfo: {
      ...state.viewportInfo,
      scrollOffset,
    },
  })),
  patchViewport: (patchFn) => set((state) => ({ viewportInfo: patchFn(state.viewportInfo) })),
}));
